/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { environment } from '../../../../environments/environment';
import { CACHE_NONCE } from '../../../core/config/cache-nonce.token';
import { SharedModule } from '../../../shared/shared.module';
import { SuccessfullyVerifiedComponent } from './successfully-verified.component';

@NgModule({
  declarations: [SuccessfullyVerifiedComponent],
  imports: [
    RouterModule.forChild([
      {
        path: '',
        pathMatch: 'full',
        component: SuccessfullyVerifiedComponent
      }
    ]),
    SharedModule
  ],
  providers: [{ provide: CACHE_NONCE, useValue: environment.config.cacheNonce }],
  exports: [SuccessfullyVerifiedComponent]
})
export class SuccessfullyVerifiedModule {}
